/** Brand icons traced from chargee.energy's inline SVGs. */

export function ArrowIcon({ className = 'size-3.5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 14 15" fill="none" className={className} aria-hidden="true">
      <path
        d="M1 7.5h11m0 0L7.6 3m4.4 4.5L7.6 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export function CheckIcon({ className = 'size-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 20 20" fill="none" className={className} aria-hidden="true">
      <path
        d="M4 10.5l4 4 8-9"
        stroke="#77AF00"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
